module.exports = __webpack_public_path__ + "img/Dual-protocol.d7c2e47d.png";